import React from "react";
import ByEvents from "./ByEvents";
import ByState from "./ByState";
import EventsOverTime from "./EventsOverTime";
import { FilterProvider } from "./FilterContext";
import { FilterRow } from "./FilterRow";
import MostProblematicRoutes from "./ProblemRoutes";



const DashboardPage: React.FC = () => {
  return (
    <FilterProvider>
      <div className="container mx-auto px-4 mb-8">
        <FilterRow />
        <EventsOverTime />
        <div className="mt-6 flex flex-wrap md:flex-nowrap gap-4">

          <div className="w-full md:w-1/2">
            <ByEvents />
          </div>
          <div className="w-full md:w-1/2">
            <MostProblematicRoutes />
          </div>
        </div>
        <div className="mt-6">
          <ByState />
        </div>
      </div>
    </FilterProvider>
  );
};

export default DashboardPage;
